import type { DocCategory } from '../registry';
import Index, { toc as indexToc } from '../pages/get-started/index';
import Quickstart, { toc as quickstartToc } from '../pages/get-started/quickstart';
import Install, { toc as installToc } from '../pages/get-started/install';

export const getStarted: DocCategory = {
  id: 'get-started',
  label: 'Get started',
  pages: [
    {
      slug: '',
      title: 'ClipRadar Documentation',
      eyebrow: 'Get started',
      description: 'Get oriented and find your starting point — search your footage, learn the interface, or connect an AI agent.',
      toc: indexToc,
      Body: Index,
      related: [
        { label: 'Quickstart', to: '/docs/quickstart' },
        { label: 'How ClipRadar works', to: '/docs/concepts/how-it-works' },
        { label: 'Agentic editing (MCP)', to: '/docs/concepts/agentic-editing' },
      ],
    },
    {
      slug: 'quickstart',
      title: 'Quickstart',
      eyebrow: 'Get started',
      description: 'Go from zero to your first search in six steps.',
      toc: quickstartToc,
      Body: Quickstart,
      related: [
        { label: 'Download & install', to: '/docs/install' },
        { label: 'How ClipRadar works', to: '/docs/concepts/how-it-works' },
        { label: 'Search tab', to: '/docs/interface/search' },
        { label: 'From search results to a rough cut', to: '/docs/guides/build-a-rough-cut' },
      ],
    },
    {
      slug: 'install',
      title: 'Download & install',
      eyebrow: 'Get started',
      description: 'Download, install, and get through first launch — the real nsis-web installer flow, end to end.',
      toc: installToc,
      Body: Install,
      related: [
        { label: 'Quickstart', to: '/docs/quickstart' },
        { label: 'System requirements', to: '/docs/reference/system-requirements' },
        { label: 'Where ClipRadar stores things', to: '/docs/reference/where-your-data-lives' },
        { label: "ClipRadar can't find my GPU", to: '/docs/troubleshooting/gpu-not-detected' },
      ],
    },
  ],
};
